import { Component, Input, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { ContentListService } from 'src/app/content-list-management/shared/services/cmsapi/content-list.service';
import { IAutoCompleteData } from '../../interfaces/i-auto-complete-data';
import { IContentList } from 'src/app/core/models/i-content-list';
import { FormArray, FormControl } from '@angular/forms';
import {
  distinctUntilChanged,
  debounceTime,
  finalize,
  switchMap,
  tap,
} from 'rxjs/operators';
import {
  ISelectListItem,
  SelectListItem,
} from '../../interfaces/i-select-list-item';

@Component({
  selector: 'app-content-list',
  templateUrl: './content-list.component.html',
  styleUrls: ['./content-list.component.scss'],
})
export class ContentListComponent implements OnInit {
  // Add input for form control
  @Input() isExpandedByDefault = true;
  @Input() isExpandable = true;
  @Input() websites: string[];
  @Input() contentListControl: FormArray;

  isSearching: boolean = false;
  searchFormControl: FormControl = new FormControl('');

  searchResults: IAutoCompleteData[];
  manuallySelectedList: ISelectListItem[] = [];

  contentListResults: IContentList[];
  constructor(public contentListService: ContentListService) {}

  ngOnInit() {
    this._initContentLists();
    this._initValueChanges();
  }

  _initContentLists(): void {
    if (this.contentListControl?.value) {
      this.manuallySelectedList = this.contentListControl.value.map((y) => {
        return new SelectListItem(y.id, y.name);
      });
    }
  }

  _initValueChanges(): void {
    this.contentListControl.valueChanges.subscribe({
      next: (x) => {
        this.manuallySelectedList = x.map((y) => {
          return new SelectListItem(y.id, y.name);
        });
      },
    });

    this.searchFormControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        debounceTime(500),
        tap(() => {
          this.isSearching = true;
        }),
        switchMap((searchedValue: string) => {
          const getDataObs$ = searchedValue
            ? this.contentListService.getSuggested$(
                searchedValue,
                this.websites
              )
            : of(null);

          return getDataObs$.pipe(
            finalize(() => {
              this.isSearching = false;
            })
          );
        })
      )
      .subscribe({
        next: (x: IContentList[]) => {
          if (x) {
            this.contentListResults = x;
            this.searchResults = x.map((p) => {
              return { displayName: p.name, id: p.id };
            });
          }
        },
      });
  }

  removeContentList($event: ISelectListItem) {
    let index = this.contentListControl.value.findIndex(
      (cl) => cl.id === $event.id
    );
    this.contentListControl.removeAt(index);

    this.resetSearchResults();
  }

  addContentList($event: IAutoCompleteData) {
    // If content list is already added ignore it
    if (
      this.contentListControl.value.filter((x) => x.id === $event.id).length ===
      0
    ) {
      let selectedContentList = this.contentListResults.filter(
        (x) => x.name === $event.displayName
      );

      this.contentListControl.push(new FormControl(selectedContentList[0]));
      this.resetSearchResults();
    }
  }

  resetSearchResults() {
    this.searchResults = [];
    this.contentListResults = [];
  }
}
